(() => {
  const root = document.querySelector('.bf-product');
  if (!root) return;
  const form = root.querySelector('#bf-form');
  const variants = JSON.parse(document.getElementById('bf-variants').textContent);
  const config = JSON.parse(document.getElementById('bf-purchase-config').textContent);
  const status = document.getElementById('bf-status');
  const submit = form.querySelector('[type=submit]');
  const money = amount => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(amount / 100).replace('￥', '¥');
  const current = () => variants.find(variant => String(variant.id) === form.elements.id.value);
  const selectedPlan = () => String(new FormData(form).get('selling_plan') || '');
  const allocationFor = (variant, planId = selectedPlan()) => (variant?.plans || []).find(plan => String(plan.id) === planId);
  async function persistAttribution() {
    // Complete the cart write before navigating: the vendor's event request is asynchronous.
    // Copy the existing RedTrack ID only; never generate a conversion or a replacement ID.
    try {
      const cookie = document.cookie.split('; ').find(value => value.startsWith('rtkclickid-store='));
      const clickId = cookie ? decodeURIComponent(cookie.slice(cookie.indexOf('=') + 1)) : sessionStorage.getItem('rtkclickid');
      if (!/^[a-f0-9]{24}$/i.test(clickId || '')) return;
      const attributes = { __clickid: clickId };
      const campaign = new URL(location.href).searchParams.get('cmpid');
      if (/^[a-f0-9]{24}$/i.test(campaign || '')) attributes.__rt_campaign_id = campaign;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
        signal: AbortSignal.timeout(4000)
      });
    } catch (_) {
      // A tracking outage must not prevent a customer from completing a purchase.
    }
  }
  root.querySelectorAll('.bf-thumb').forEach(button => button.addEventListener('click', () => {
    const image = document.getElementById('bf-main-image');
    image.removeAttribute("srcset");
    image.src = button.dataset.image;
    image.alt = button.querySelector('img').alt;
    root.querySelectorAll('.bf-thumb').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  const thumbs = [...root.querySelectorAll('.bf-thumb')];
  root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
    const index = thumbs.findIndex(item => item.getAttribute('aria-pressed') === 'true');
    const next = (index + Number(button.dataset.galleryStep) + thumbs.length) % thumbs.length;
    thumbs[next].click();
    thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }));
  const subscribe = document.getElementById('bf-subscribe');
  const planSelect = document.getElementById('bf-plan-select');
  if (subscribe && planSelect) subscribe.addEventListener('change', () => {
    planSelect.disabled = !subscribe.checked;
    planSelect.hidden = !subscribe.checked;
    document.querySelector('.bf-cadence-label').hidden = !subscribe.checked;
    document.querySelector('.bf-recurring').hidden = !subscribe.checked;
    update(false);
  });
  function update(writeUrl = true) {
    const variant = current();
    if (!variant) return;
    const planId = selectedPlan();
    const allocation = allocationFor(variant, planId);
    submit.disabled = config.currency !== 'USD' || config.country !== 'US' || !variant.available || Boolean(planId && !allocation) || form.getAttribute('aria-busy') === 'true';
    document.getElementById('bf-sticky-price').textContent = money(allocation ? allocation.price : variant.price);
    const note = document.getElementById('bf-purchase-note');
    if (note) note.textContent = allocation ? allocation.name + ' · ' + money(allocation.price) + ' per delivery' : note.dataset.once;
    variants.forEach(item => {
      const offer = form.querySelector('[data-offer="' + item.id + '"]');
      const plan = allocationFor(item, planId);
      const price = plan ? plan.price : item.price;
      offer.querySelector('.bf-price').textContent = money(price);
      const compare = offer.querySelector('.bf-compare');
      const discount = offer.querySelector('.bf-discount');
      compare.hidden = !(item.compare_at_price > price);
      discount.hidden = compare.hidden;
      if (!compare.hidden) discount.textContent = Math.round((item.compare_at_price - price) / item.compare_at_price * 100) + '% OFF';
    });
    if (writeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
    status.textContent = config.currency === 'USD' && config.country === 'US' ? '' : 'US prices could not load. Please allow essential cookies and reload this page.';
  }
  root.addEventListener('change', event => {
    if (event.target.name === 'bf_variant') {
      form.elements.id.value = event.target.value;
      update();
      return;
    }
    requestAnimationFrame(() => update());
  });
  root.addEventListener('click', event => {
    if (event.target.closest('kaching-bundles-block')) requestAnimationFrame(() => update());
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = current();
    if (!variant?.available || submit.disabled) return;
    const planId = selectedPlan();
    const allocation = allocationFor(variant, planId);
    if (planId && !allocation) return;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = config.adding;
    try {
      const properties = {};
      for (const [name, value] of new FormData(form)) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      const line = { id: variant.id, quantity: 1, properties };
      if (allocation) line.selling_plan = allocation.id;
      const response = await fetch(config.addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || config.error);
      await persistAttribution();
      location.href = config.checkoutUrl;
    } catch (error) {
      status.textContent = error.message || config.error;
      submit.disabled = !variant.available;
      form.removeAttribute('aria-busy');
    }
  });
  const sticky = document.getElementById('bf-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(form);
  }
  update(false);
})();
